import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation, Trans } from "react-i18next";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import BusinessCustomersActions from "../../Redux/transition/customers/business-customer.reducer";
import CustomToast from "../../Components/CustomToast";
import "../../Styles/pages/product.scss";
import "../../Styles/components/tags.scss";

const RemoveAudienceMemberDialog = ({ visible, onHide, audienceId, memberId, memberName, onRemoved }) => {
    const { t } = useTranslation("common");
    const dispatch = useDispatch();

    const [confirmClicked, setConfirmClicked] = useState(false);
    const [toastTrigger, setToastTrigger] = useState(false);
    const [toastData, setToastData] = useState({ summary: "", severity: "", detail: "", life: 0 });

    const { removingAudienceMember, removedAudienceMember, removeAudienceMemberError } = useSelector(
        (state) => state.businessCustomers
    );

    const removeMember = useCallback(
        (id, joinId) => dispatch(BusinessCustomersActions.removeAudienceMemberRequest(id, joinId)),
        [dispatch]
    );

    useEffect(() => {
        if (!removingAudienceMember && removedAudienceMember && confirmClicked) {
            setToastData({
                summary: t("success"),
                severity: "success",
                detail: t("business_customers.audience_remove_member_success"),
                life: 3000,
            });
            setToastTrigger(true);
        }
        if (!removingAudienceMember && removeAudienceMemberError && confirmClicked) {
            setToastData({
                summary: t("err"),
                severity: "error",
                detail: t("business_customers.audience_remove_member_error"),
                life: 4000,
            });
            setToastTrigger(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [removingAudienceMember, removedAudienceMember, removeAudienceMemberError, confirmClicked]);

    const handleClose = () => {
        setConfirmClicked(false);
        onHide();
    };

    const handleConfirm = () => {
        if (!audienceId || !memberId) {
            return;
        }
        setConfirmClicked(true);
        removeMember(audienceId, memberId);
    };

    return (
        <Dialog
            header={t("business_customers.audience_remove_member")}
            visible={visible}
            style={{ width: "350px" }}
            onHide={handleClose}
        >
            <CustomToast
                {...toastData}
                trigger={toastTrigger}
                handleActionsAfterToast={() => {
                    setToastTrigger(false);
                    setConfirmClicked(false);
                    handleClose();
                    onRemoved?.();
                }}
                handleActionsAfterErrorToast={() => {
                    setToastTrigger(false);
                    setConfirmClicked(false);
                }}
            />

            <div className="p-fluid remove-main-div">
                <div className="mt-3">
                    {memberName ? (
                        <p className="mb-0">
                            <Trans
                                i18nKey="business_customers.audience_remove_member_hint"
                                values={{ memberName }}
                                components={{
                                    1: <span className="bold_black_hint" />,
                                }}
                            />
                        </p>
                    ) : (
                        <p className="normal_hint mb-0">{t("business_customers.audience_remove_member_confirm")}</p>
                    )}
                    <hr className="tag_hr mt-3 mb-0" />
                </div>

                <div className="p-field p-mb-3 mt-4">
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem" }}>
                        <Button
                            label={t("subscriber.cancel")}
                            className="mr-1"
                            icon="pi pi-times"
                            onClick={handleClose}
                            id="cancel-tag-button"
                            type="button"
                        />
                        <Button
                            type="button"
                            label={t("business_customers.audience_remove_member")}
                            className="p-mt-2 save-btns"
                            onClick={handleConfirm}
                            loading={removingAudienceMember}
                            disabled={confirmClicked || removingAudienceMember}
                        />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default RemoveAudienceMemberDialog;
